import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { gearIcon } from '@g99-product-web-ui/shared-util-lib';

import { IColumnPreference } from '../../interfaces/shared-table-column-preference.interface';

@Component({
  selector: 'lib-g99-shared-table-column-preference',
  templateUrl: './shared-table-column-preference.component.html',
  styleUrls: ['./shared-table-column-preference.component.scss'],
  standalone: false,
})
export class SharedTableColumnPreferenceComponent implements OnChanges {
  @Input() public availableColumns: IColumnPreference[] = [];
  @Output() public savePreference = new EventEmitter<IColumnPreference[]>();

  @ViewChild('popoverRef') protected popoverRef: any;

  public searchText = '';
  public selectedMap: Record<string, boolean> = {};
  protected icon = gearIcon;
  protected isSubmitting = false;

  protected _initialSortedColumns: Array<{
    label: string;
    value: string;
    locked?: boolean;
  }> = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['availableColumns']) {
      this._buildSelectionMap();
    }
  }

  protected get filteredColumns(): Array<{
    label: string;
    value: string;
    locked?: boolean;
  }> {
    const search = this.searchText?.toLowerCase();
    return this._initialSortedColumns
      .filter((col) => col.label?.toLowerCase()?.includes(search))
      .map((col) => ({
        ...col,
        selected: this.selectedMap[col.value] || false,
      }));
  }

  protected onPopoverOpen(event: Event): void {
    this.searchText = '';
    this._buildSelectionMap();
    this.popoverRef?.toggle?.(event);
  }

  protected reset(): void {
    this._buildSelectionMap();
  }

  protected save(): void {
    const updatedColumns = this.availableColumns.map((col) => ({
      ...col,
      visible: this.selectedMap[col.columnId] || !!col.locked,
    }));
    this.savePreference.emit(updatedColumns);
    this.popoverRef?.hide?.();
  }

  private _buildSelectionMap(): void {
    // Exclude system/internal fields like "checkbox"
    const filtered = this.availableColumns.filter(
      (col) => col.columnId !== 'checkbox'
    );

    this.selectedMap = filtered.reduce(
      (map, col) => {
        map[col.columnId] = col.visible;
        return map;
      },
      {} as Record<string, boolean>
    );

    this._initialSortedColumns = filtered
      .map((col) => ({
        label: col.label,
        value: col.columnId,
        locked: col.locked,
      }))
      .sort((a, b) => {
        const aSelected = this.selectedMap[a.value];
        const bSelected = this.selectedMap[b.value];
        return +bSelected - +aSelected; // Sort selected to top
      });
  }
}
